import { render, staticRenderFns } from "./news-list-toolbar.vue?vue&type=template&id=2c105470&"
import script from "./news-list-toolbar.vue?vue&type=script&lang=js&"
export * from "./news-list-toolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports